import styled from 'styled-components';
import React from 'react';
import { Link } from 'react-router-dom';
import { useEntityRegistry } from '../useEntityRegistry';
import { PageRoutes } from '../../conf/Global';
import { IconStyleType } from '../entity/Entity';
import { EntityType } from '../../types.generated';
import { LogoCountCard } from '../shared/LogoCountCard';
import { EventType } from '../analytics/event';
import analytics from '../analytics';
// import { navigateToSearchUrl } from './utils/navigateToSearchUrl';
// import { ENTITY_SUB_TYPE_FILTER_NAME } from './utils/constants';
// import { useIsBrowseV2 } from './useSearchAndBrowseVersion';

const BrowseEntityCardWrapper = styled(Link)`
    cursor: pointer;
    text-decoration: none;
    tab-index: 0;
`;

export const BrowseEntityCard = ({ entityType, count }: { entityType: EntityType; count: number }) => {
    const entityRegistry = useEntityRegistry();
    // const showBrowseV2 = useIsBrowseV2();
    const isGlossaryEntityCard = entityType === EntityType.GlossaryTerm;
    const entityPathName = entityRegistry.getPathName(entityType);
    let url = `${PageRoutes.BROWSE}/${entityPathName}`;
    if (isGlossaryEntityCard) {
        url = PageRoutes.GLOSSARY;
    } else if (entityType === EntityType.DataProduct) {
        url = PageRoutes.BROWSE_DATAPRODUCT;
    }

    const onBrowseEntityCardClick = () => {
        analytics.event({
            type: EventType.HomePageBrowseResultClickEvent,
            entityType,
        });
    };

    return (
        // TODO: Check the Link
        // <Link className="stats-tile-card-wrapper" to={url} data-testid={`entity-type-browse-card-${entityType}`}>
        <BrowseEntityCardWrapper
            to={url}
            className="stats-tile-card-wrapper f-width-100-xs"
            data-testid={`entity-type-browse-card-${entityType}`}
            tabIndex={0}
            role="button"
        >
            <LogoCountCard
                logoComponent={entityRegistry.getIcon(entityType, 18, IconStyleType.HIGHLIGHT)}
                name={entityRegistry.getCollectionName(entityType)}
                count={count}
                onClick={onBrowseEntityCardClick}
            />
        </BrowseEntityCardWrapper>
    );
};
